export const LISTING_PUBLICATION_SCHEDULE_FIELD_NAME = 'scheduled_at'

export const QA_NAME_LISTING_PUBLICATION_SCHEDULE_MODAL =
  'listingPublicationScheduleModal'

export const QA_NAME_LISTING_PUBLICATION_SCHEDULE_FIELD =
  'listingPublicationScheduleField'
